module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/cover-kyoto-2-f2fac7e991ce6bb3c6ccef70baabb5a1.webp";